<template>
  <div>
    <b-row v-if="showStepper" class="fixed-top bg-white border-bottom">
      <b-col class="py-3">
        <onboarding-stepper
          :options="{
            paddingBottom: false,
            borderBottom: false,
          }"
          :currentStep="currentStep"
          :steps="steps"
        />
      </b-col>
    </b-row>
    <b-row class="py-4">
        <b-col cols="12" md="8" offset-md="2">
            <b-card>
                <h1>Company Setup</h1>
                <p>Upload the company's big and small logos, along with their preferred color theme.</p>
                <advanced-form
                  autocomplete="off"
                  layout="inline-md-3"
                  submit-label="Save"
                  v-bind="formFields"
                  v-model="form"
                  @submit="input()"
                />
            </b-card>
        </b-col>
    </b-row>
    <b-row v-if="showStepper" class="fixed-bottom border-top p-2 bg-white">
      <b-col>
        <b-btn variant="primary" class="float-right" @click="saveAndNext">
          Save & Next
        </b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AdvancedForm from '@/components/AdvancedForm';
import OnboardingStepper from '@/components/profile/OnboardingStepper';
import gql from 'graphql-tag';
import CurrentCompanyFragment from '@/graphql/fragments/CurrentCompany.gql';
import AssetDetailsFragment from '@/graphql/fragments/AssetDetails.gql';

const CompanyBrandingUpdateMutation = gql`
    mutation CompanyBrandingUpdate($update: CompanyUpdateInput!) {
        updateCompany(update: $update) {
            ...CurrentCompany
        }
    }
    ${CurrentCompanyFragment}
    ${AssetDetailsFragment}
`;

const CurrentCompanyBrandingSetupQuery = gql`
    query CurrentCompanyBrandingSetup {
        company {
            name
            branding {
                bigLogo {
                    id
                    fileName
                    fileSize
                    fileLocation
                }
                smallLogo {
                    id
                    fileName
                    fileSize
                    fileLocation
                }
                socialImage {
                    id
                    fileName
                    fileSize
                    fileLocation
                }
                primaryColour 
            }
        }
    }
`;

export default {
  components: {
    AdvancedForm,
    OnboardingStepper
  },
  props: {
    currentStep: {
      type: Object,
      default: () => ({
        name: 'company-setup',
        displayName: 'Company Branding'
      }),
    },
    steps: {
      type: Array,
      default: () => [
        {
          name: 'company-setup',
          displayName: 'Company Branding',
          stepper: true
        },
        {
          name: 'campaign-jobs',
          displayName: 'Jobs',
          stepper: true
        },
        {
          name: 'campaign-content-share',
          displayName: 'Content',
          stepper: true
        },
        {
          name: 'event-settings',
          displayName: 'Event Settings',
          stepper: true
        }
      ],
    }
  },
  data: () => ({
    form: null,
    showStepper: false,
  }),
  mounted() {
    console.log('Current Query: ', this.$route.query);
    if (this.$route && this.$route.query && this.$route.query.setup && this.$route.query.eventID) {
      this.showStepper = !this.showStepper;
    }
  },
  computed: {
    formFields() {
      const form = {
        bigLogo: {
          label: 'Big Logo',
          type: 'FILE',
          helpText: 'Insert the Big Logo of the Company.',
          required: true,
          options: {
            type: 'IMAGE',
            accept: '.jpg,.jpeg,.gif,.png',
            showPreview: true
          }
        },
        smallLogo: {
          label: 'Small Logo',
          type: 'FILE',
          helpText: 'Insert the Small Logo of the Company',
          required: true,
          options: {
            type: 'IMAGE',
            accept: '.jpg,.jpeg,.gif,.png',
            showPreview: true
          }
        },
        socialImage: {
          label: 'Social Image',
          type: 'FILE',
          helpText: 'Insert the Social Image of the Company',
          required: true,
          options: {
            type: 'IMAGE',
            accept: '.jpg,.jpeg,.gif,.png',
            showPreview: true
          }
        },
        companyColor: {
          label: 'Company Colour',
          type: 'COLOR-PICKER',
          helpText: 'Choose the Theme Colour the Company wants to use',
          required: true,
          options: {
            defaultValue: '#ffffff'
          }
        }
      };

      return { form };
    },
  },
  apollo: {
    branding: {
      query: CurrentCompanyBrandingSetupQuery,
      update({ company }) {
        this.form = company.branding;
      }
    }
  },
  methods: {
    async input() {
      try {
        const update = {
          branding: {
            primaryColour: this.form.companyColor,
            bigLogo: {
              id: this.form.bigLogo.id
            },
            smallLogo: {
              id: this.form.smallLogo.id
            },
            socialImage: {
              id: this.form.socialImage.id
            },
          }
        };
        await this.$apollo.mutate({
          mutation: CompanyBrandingUpdateMutation,
          variables: { update }
        });
        this.$bvToast.toast('Refresh the page if needed.', {
          title: 'Company Branding has been applied',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center'
        });
      } catch (error) {
        console.log(error);
      }
    },
    async saveAndNext() {
      await this.input();
      this.$router.push(
        {
          name: 'CampaignJobIndex',
          query: { setup: true, eventID: this.$route.query.eventID }
        }
      );
    }
  },
};
</script>

<style lang="scss">
.referral-jam-event-settings {
  .event-logo {
    max-height: 30px;
    max-width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/settings/Setup.vue